import type { RichEditorPreset } from '@odo/shared-ui';
import { toDoc } from './docBuilders.ts';
import { filled, type VcaNoteFields } from './noteFields.ts';

export function refinementNotesPreset(fields: VcaNoteFields): RichEditorPreset {
    const f = filled(fields);
    return {
        id: 'refinement-template',
        label: 'Refinement template',
        description: 'Doctor, patient and current aligner filled in; edit the rest.',
        doc: toDoc([
            [[`Good Morning/Afternoon Dr. ${f.doctor},`]],
            [
                [
                    `${f.patientFirstName} is approaching the end of their aligner set and will soon be ready for a refinement scan.`
                ],
                [
                    "We're reaching out now so your office has time to plan; there is no need to see the patient immediately."
                ]
            ],
            [
                [
                    { bold: 'Aligner Status' },
                    `: current aligner ${f.aligner}; aligners [#–#] passive.`
                ],
                [
                    'Once the patient reaches their final aligner, DentalMonitoring will be paused and status will update to On Hold.'
                ]
            ],
            [
                [
                    { bold: 'Ortho Notes' },
                    ': refinement is the next step to continue the original treatment plan.'
                ]
            ],
            [
                [
                    { bold: '(Edit/remove)' },
                    ' Caplin hooks and lingual attachments were not placed at aligner [#] per the SDI; place before the IO scan.'
                ],
                [
                    { bold: 'Clinical Feedback:' },
                    ' a brief note from the doctor and patient after the visit is very helpful.'
                ]
            ],
            [[{ bold: 'DM Notifications' }, ': [Insert concern].']],
            [['Thank you!']]
        ])
    };
}
